import React from "react";

const INITIAL_STATE = {
    isOpen: false,
    outcome: null
};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "Notifications.SHOW":
            return {...state, isOpen: true, outcome: action.payload.outcome};
        case "Notifications.HIDE":
            return {...state, isOpen: false};
        default:
            return state;
    }
}

export function showNotifications(outcome) {
    return {type: "Notifications.SHOW", payload: {outcome}};
}

export function hideNotifications() {
    return {type: "Notifications.HIDE", payload: null};
}
